<template lang="html">

  <section class="destacados pad-sec">
    <div class="container">
      <h2 class="title title-36">{{$t('home.destacados.titulo')}}</h2>
      <div class="flex wrap justify-between">
        <destacado-el v-for="(e, key) in destacados" :data="e" :key="key"></destacado-el>
      </div>
    </div>
  </section>

</template>

<script lang="js">

  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  Vue.use(VueAxios, axios);

  import Destacado_el from '@/components/parts/destacado-el';

  import { mapGetters } from 'vuex'

  export default  {
    name: 'destacados',
    props: [],
    mounted() {
      this.getData();
    },
    data() {
      return {
        destacados : ''
      }
    },
    methods : {
      getData (){
        axios.get(`destacados?lang=${this.getLanguage}`)
        .then(response => {
          this.destacados = response.data.destacados;
        })
        .catch(error => console.log(error));
      }
    },
    computed: {
      ...mapGetters(['getLanguage'])
    },
    components: {
      'destacado-el' : Destacado_el
    },
    watch : {
      'getLanguage' (){
        this.getData();
      }
    }
  }
</script>

<style scoped>
.art-dest{
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/home/destacados.vue